'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
const $ = require("jquery");
class Common {
    constructor() {
        const self = this;
        $('a[href^="#"]').click(function () {
            const href = $(this).attr("href");
            if (self.isAnchor(href)) {
                self.scrollToAnchor(href);
                return false;
            }
        });
        // URLがアンカーリンク付きだった時
        // window.addEventListener('load', () => {
        $(window).on('load', () => {
            const url = location.href;
            if (this.isAnchor(url)) {
                $('.bulletHeader').attr('data-is-top', 'false');
                $("html, body").animate({ scrollTop: 0 }, 0, 'linear');
                setTimeout(() => {
                    self.scrollToAnchor(url);
                }, 300);
                return false;
            }
        });
    }
    isAnchor(href) {
        return href.indexOf('#') != -1;
    }
    getAnchorName(href) {
        const index = href.indexOf('#');
        return href.slice(index + 1);
    }
    scrollToAnchor(href) {
        const headerHeight = $('.paramHeader').outerHeight() || 0;
        const anchor = this.getAnchorName(href);
        const position = $('#' + anchor).offset().top - headerHeight;
        $("html, body").animate({ scrollTop: position }, 400, 'linear');
    }
}
exports.Common = Common;
exports.default = Common;
